<footer [ngClass]="{'full-width': !expand}" class="footer">
  <div>
    Copyright
  </div>
</footer>
